<template>
  <div class="card border-0 rounded-3 bg-white mb-4">
    <div class="card-body p-4">
      <div class="d-flex align-items-end">
        <div class="flex-grow-1">
          <span class="d-block mb-1">Total Item</span>
          <h4 class="fs-20 mb-0">{{ total }}</h4>
        </div>
        <div class="flex-shrink-0 me-3 me-auto">
          <i
            class="ri-truck-line fs-24 text-white bg-primary d-inline-block text-center rounded-circle text-white"
            style="width: 60px; height: 60px; line-height: 60px"
          ></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "TotalItem",
  props: {
    total: {
      type: Number,
      required: true,
      default: 0,
    },
  },
});
</script>
